export default __webpack_public_path__ + "static/media/Spinner.ba19e3ce.gif";